import { useCallback, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import { eventList, glb_sv, sendRequest, serviceList, session } from 'src/utils';
import crypt from 'src/utils/service/crypt';
import { toast } from 'react-toastify';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import Iconify from 'src/components/iconify/Iconify';
import ConfirmModal from 'src/components/modal/ConfirmDeviceModal';
import { useTranslation } from 'react-i18next';
import socket_sv from 'src/utils/service/SocketSv';
import SignalWifiStatusbarConnectedNoInternet4Icon from '@mui/icons-material/SignalWifiStatusbarConnectedNoInternet4';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import useNetworkRTT from 'src/hooks/useNetworkRTT';
import useCheckConnectionToServer from 'src/hooks/useCheckConnectionToServer';
import useResponsive from 'src/hooks/useResponsive';
// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 80;

const StyledRoot = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    paddingTop: APP_BAR_MOBILE + 24,
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.up('lg')]: {
        paddingTop: APP_BAR_DESKTOP + 24,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
}));
// ----------------------------------------------------------------------
function Copyright() {
    const version = localStorage.getItem('version');
    return (
        <Typography variant="body2" color="text.secondary">
            {'© ' + ' 2023 OHNOSEIKO.  Powered by  '}
            <Link underline="none" color="text.secondary" href="https://chips.vn/">
                <span
                    style={{
                        fontweight: 'bold',
                        fontsize: '18px',
                    }}
                >
                    Chips v{version}
                </span>
            </Link>
        </Typography>
    );
}
// ----------------------------------------------------------------------

export default function DashboardLayout() {
    const [open, setOpen] = useState(false);
    const networkRTT = useNetworkRTT();
    const { countDisconect: countConectionServer, setCountDisconect: setCountDisconectServer } =
        useCheckConnectionToServer();
    const [countDisconect, setCountDisconect] = useState(0);
    let deviceId = localStorage.getItem('device_id');
    const [elementConection, setElementConection] = useState(
        <>
            {glb_sv.countConection <= 1 ? (
                <Typography color={'text.success'} sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <Iconify icon={'material-symbols:wifi'} width={20} height={20} />
                </Typography>
            ) : (
                ''
            )}
            {glb_sv.countConection > 1 && glb_sv.countConection <= 2 ? (
                <Typography color={'text.warning'} sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <Iconify icon={'material-symbols:wifi-2-bar-sharp'} width={20} height={20} />
                </Typography>
            ) : (
                ''
            )}
            {glb_sv.countConection >= 3 ? (
                <Typography color={'text.error'} sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <Iconify icon={'material-symbols:wifi-off'} width={20} height={20} />
                </Typography>
            ) : (
                ''
            )}
        </>
    );
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [dataCabinet, setDataCabinet] = useState([]);

    const userData = sessionStorage.getItem('proc_data');
    const menu = sessionStorage.getItem('menu');
    if (!userData || !menu) {
        navigate('/login');
    }

    useEffect(() => {
        glb_sv.commonEvent.subscribe((msg) => {
            if (msg.type === eventList.EXPIRE_SESSION) {
                setOpen(true);
                setTimeout(() => {
                    sessionStorage.removeItem('proc_data');
                    sessionStorage.removeItem('menu');

                    sessionStorage.removeItem('category');
                    glb_sv.authFlag = false;
                }, 1000);
            }
        });
    }, []);
    const handleLogout = () => {
        let InVal = [];
        sendRequest(serviceList.logout, InVal, logoutResult, true, timeOutFunct, 40000);
    };

    const logoutResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            logoutIOT();
            navigate('/login');
        }
    };

    const timeOutFunct = (reqInfo) => {};

    // region CALL API login IOT

    const logoutIOT = () => {
        const cabinet_cd = glb_sv.getLocalStorageCabinet('cabinet');
        console.log('cabinet_cd', cabinet_cd);
        sendRequest(
            serviceList.logoutIOT,
            [cabinet_cd?.cabinet_cd || ''],
            logoutIOTResult,
            true,
            timeOutFunctIOT,
            40000,
            0
        );
    };
    const logoutIOTResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            toast.success('Error: ' + message['proc_message']);
        }
    };
    const timeOutFunctIOT = (e) => {
        toast.error(t('error.time_out') + ' IOT');
    };
    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        const menu = sessionStorage.getItem('menu');
        const language = localStorage.getItem(session.LOCAL_LANGUAGE);
        i18n.changeLanguage(language);
        if (!userData || !menu) {
            navigate('/login');
        }
        if (userData && menu) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                glb_sv.userInfo = data;
                glb_sv.menu = JSON.parse(crypt.deCode(menu));
                glb_sv.sessionInfo.comp_id = data.o_3;
                glb_sv.sessionInfo.branch_id = data.o_4;
                glb_sv.sessionInfo.user_id = data.id;
            } catch (error) {}
        }
    }, []);

    useEffect(() => {
        if (!networkRTT || networkRTT >= 300) {
            setCountDisconect(2);
            renderStatusWifi(2);
            setCountDisconectServer(2);
        } else if (networkRTT >= 120 && networkRTT) {
            setCountDisconect(1);
        } else {
            setCountDisconect(0);
        }
    }, [networkRTT]);

    useEffect(() => {
        if (countConectionServer === 0) {
            renderStatusWifi(countDisconect);
            // setCountDisconectServer(countDisconect);
        } else {
            renderStatusWifi(countConectionServer);
        }
    }, [countConectionServer, countDisconect]);

    // useEffect(() => {
    //     const checkHeartBeat = setInterval(() => {
    //         // console.log('check ping');
    //         if (dataCabinet && dataCabinet.length > 0) {
    //             dataCabinet.forEach((data) => {
    //                 try {
    //                     const service =
    //                         data?.cabinet_type !== 'round'
    //                             ? serviceList.checkHeartbeat
    //                             : serviceList.checkHeartbeatCabinetV2;
    //                     const inpuVal = [data?.cabinet_cd || 'CBNOHN011', 'ping'];
    //                     // sendRequest(service, inpuVal, checkHeartBeatResult, true, timeOutFunctcheckHeartBeat, 40000, 0);
    //                     // console.log("Dashboard Inpuval", inpuVal);
    //                     // console.log("Dashboard Service", service);
    //                 } catch (error) {
    //                     console.error('Error sending heartbeat check request:', error);
    //                 }
    //             });
    //         }
    //     }, 40000);
    //     return () => clearInterval(checkHeartBeat);
    // }, []);

    // const checkHeartBeatResult = (reqInfoMap, message) => {
    //     if (message['proc_status'] === "0") {
    //         setCountDisconect(countDisconect + 1);
    //         glb_sv.countConection = glb_sv.countConection + 1;
    //         toast.error('Error: ' + message['proc_message']);
    //         renderStatusWifi(glb_sv.countConection);
    //     } else {
    //         setCountDisconect(0);
    //         glb_sv.countConection = 0;
    //         renderStatusWifi(glb_sv.countConection);
    //     }
    // };

    // const timeOutFunctcheckHeartBeat = (reqInfo) => {
    //     setCountDisconect(countDisconect + 1);
    //     glb_sv.countConection = glb_sv.countConection + 1;
    //     renderStatusWifi(glb_sv.countConection);
    // };

    // Ví dụ: networkRTT là biến số bạn muốn hiển thị
    const getNetworkRTTColor = (networkRTT) => {
        if (networkRTT > 300) return 'red';
        if (networkRTT > 120) return 'yellow';
        return 'inherit'; // hoặc màu mặc định
    };

    const renderStatusWifi = (count = 0) => {
        if (count < 1) {
            setElementConection(
                <Typography
                    color={'text.success'}
                    data={countDisconect}
                    sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}
                >
                    <Iconify icon={'material-symbols:wifi'} width={20} height={20} />
                </Typography>
            );
        }
        if (count >= 1 && count < 2) {
            setElementConection(
                <Typography
                    data={countDisconect}
                    color={'text.warning'}
                    sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}
                >
                    <SignalWifiStatusbarConnectedNoInternet4Icon width={20} height={20} />
                </Typography>
            );
        }
        if (count >= 2) {
            setElementConection(
                <Typography color={'text.error'} sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <WifiOffIcon width={20} height={20} />
                </Typography>
            );
        }
    };

    useEffect(() => {
        getDataCabinet();
    }, []);

    const getDataCabinet = useCallback(() => {
        const InVal = [];
        sendRequest(serviceList.getAllCabinetSp, InVal, getDataCabinetResult, true, timeOutFunctCabinet, 40000);
    }, []);

    const getDataCabinetResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataCabinet(message.proc_data.rows[0].o_1);
        }
    };

    const timeOutFunctCabinet = (reqInfo) => {};
    const mdUp = useResponsive('up', 'md');
    return (
        <StyledRoot>
            {menu && userData ? (
                <>
                    <Header countDisconect={countDisconect} />
                    <ConfirmModal isExpTime setVisible={setOpen} visible={open} handleConfirm={handleLogout} />
                    <Main>
                        <Outlet />
                    </Main>
                    <Box
                        component="footer"
                        sx={{
                            py: 1,
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,

                            px: 1,
                            mt: 'auto',
                            backgroundColor: (theme) =>
                                theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800],
                        }}
                    >
                        <Container maxWidth="xl">
                            <Stack
                                sx={{
                                    display: 'flex',
                                    flexDirection: !mdUp ? 'column' : 'row', // Chuyển sang hàng dọc trên mobile
                                    justifyContent: !mdUp ? 'center' : 'space-between',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    gap: !mdUp ? 1 : 0,
                                }}
                            >
                                {!mdUp && (
                                    <Typography
                                        variant="div"
                                        sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}
                                        color="text.secondary"
                                    >
                                        <strong>{t('status_conection')}:</strong>{' '}
                                        <Typography variant="span" sx={{ color: getNetworkRTTColor(networkRTT) }}>
                                            {networkRTT} ms
                                        </Typography>
                                        {elementConection}
                                    </Typography>
                                )}

                                {!mdUp && (
                                    <Typography variant="body2" color="text.secondary">
                                        <strong>NO:</strong> {deviceId}
                                    </Typography>
                                )}

                                <Copyright />

                                {mdUp && (
                                    <Typography
                                        variant="div"
                                        sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}
                                        color="text.secondary"
                                    >
                                        <strong>NO:</strong> {deviceId} <strong>{t('status_conection')}:</strong>{' '}
                                        <Typography variant="span" sx={{ color: getNetworkRTTColor(networkRTT) }}>
                                            {networkRTT} ms
                                        </Typography>
                                        {elementConection}
                                    </Typography>
                                )}
                            </Stack>
                        </Container>
                    </Box>
                </>
            ) : (
                <></>
            )}
        </StyledRoot>
    );
}
